import StorSpinner from "./StorSpinner";

export default StorSpinner;
